import { render, staticRenderFns } from "./CarShipManagerInfo.vue?vue&type=template&id=0c3bdf60"
import script from "./CarShipManagerInfo.vue?vue&type=script&lang=js"
export * from "./CarShipManagerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports